import styled from "styled-components"

export const ButtonsWrapper = styled.div`
   display: flex;
   flex-wrap: wrap;
   cursor: pointer;
   background: none;
   border: none;
`;

